import { useEffect } from 'react'
import getRows from '../utils/getRows'
import Entity from '../types/Entity'
import compareOrder from '../utils/compareOrder'
import nestedSort from '../utils/nestedSort'

interface useInitProps {
  getAllRowsUrl: string
  relationalFieldName: string
  setIncludedRows: Function
  setExcludedRows: Function
  internalCounter: number
  includedRows: Array<Entity>
  onAddItem?: (entity: Entity) => boolean
  onAddAllItemsInvertedInitialSelection?: (entities: Entity[]) => boolean
  invertInitialSelection?: boolean
  handleIncludeRow: (entity: Entity) => void
  setShowDataInitSpinner: (showSpinner: boolean) => void
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    let originalIncludedRows: Array<Entity> = []

    //fill an array of included rows when creating a parent item to get a list of included items in state
    if (
      props.includedRows.length > 0 &&
      props.onAddItem !== undefined &&
      props.internalCounter > 0
    ) {
      originalIncludedRows = props.includedRows
    }

    getRows({ url: props.getAllRowsUrl }).then((rows) => {
      const includedRows: Array<Entity> = []
      const excludedRows: Array<Entity> = []

      rows.forEach((row: Entity, index: number, dataArray: any) => {
        if (row.order !== null || props.includedRows.some((item) => item[props.relationalFieldName] === row[props.relationalFieldName])) {
          includedRows.push(row)
        } else {
          excludedRows.push(row)
        }
      })

      if(props.invertInitialSelection === true && props.onAddAllItemsInvertedInitialSelection !== undefined){
        const temp = [...includedRows];
        includedRows.length = 0;
        includedRows.push(...excludedRows);

        excludedRows.length = 0;
        excludedRows.push(...temp);
      }

      includedRows.sort((a: Entity, b: Entity) => compareOrder(a, b))
      props.setIncludedRows(includedRows)

      props.setExcludedRows(nestedSort(excludedRows, includedRows, props.relationalFieldName))

      if (props.invertInitialSelection === true) {
        if(props.onAddAllItemsInvertedInitialSelection !== undefined){
           props.onAddAllItemsInvertedInitialSelection(includedRows)
        } else {
          //fallback
          excludedRows.forEach((row) => {
            props.handleIncludeRow(row)
          })
        }
      }
      props.setShowDataInitSpinner(false)
    })
  }, [props.internalCounter])
}

export default useInit
